<div class="overflow-auto">
    <mat-table [dataSource]="level().roomsData" [trackBy]="trackByFn">
        @for (column of columns(); track column; let idx = $index) {
            <ng-container [matColumnDef]="column.name" [sticky]="idx === 0" [stickyEnd]="idx === columns().length - 1">
                <mat-header-cell *matHeaderCellDef [style.flex]="column.flex">
                    <div class="flex items-center flex-wrap gap-1">
                        <div class="ca-text-md ca-bold">{{ column.title | translate }}</div>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" [style.flex]="column.flex">
                    @if (idx === 0) {
                        <div class="cell-wrapper cell-wrapper-ellipsis">
                            <ng-container *ngTemplateOutlet="column.templateRef; context: { $implicit: { row: row, index: i } }" />
                        </div>
                    } @else {
                        <ng-container *ngTemplateOutlet="column.templateRef; context: { $implicit: { row: row, index: i } }" />
                    }
                </mat-cell>
            </ng-container>
        }

        <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns()"></mat-row>
    </mat-table>
</div>
